/* Erstwhile theme — free gift. Loaded after theme.js when Theme settings > Free gift is on.
   Uses the cart helper that theme.js puts on window.theme.cart. */
(() => {
  'use strict';

  const theme = window.theme || {};
  const cart = theme.cart;
  if (!cart) return;
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  /* ------------------------------------------------------------ free gift
     The cart shows the gift choice (snippets/free-gift-offer.liquid). Its wrapper says which
     gift lines are in the cart and whether the cart still qualifies; this keeps the cart in line:
     at most one gift, and none below the amount or for dealers. An automatic discount in Shopify
     makes the gift free. */
  const freeGift = {
    busy: false,

    box() {
      return $('[data-free-gift]');
    },

    keys(box) {
      return (box && box.dataset.giftKeys ? box.dataset.giftKeys.split(',') : []).filter(Boolean);
    },

    showError(box, message) {
      const errorEl = box && $('[data-free-gift-error]', box);
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    },

    async choose(button) {
      if (this.busy) return;
      const box = button.closest('[data-free-gift]');
      const previous = this.keys(box);
      this.busy = true;
      button.classList.add('is-loading');
      $$('[data-free-gift-choose]', box).forEach((option) => option.setAttribute('aria-busy', 'true'));
      try {
        for (const key of previous) await cart.change(key, 0);
        await cart.add({ items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _free_gift: '1' } }] }, { open: false });
      } catch (error) {
        this.showError(this.box() || box, error.message);
      } finally {
        this.busy = false;
        button.classList.remove('is-loading');
        $$('[data-free-gift-choose]').forEach((option) => option.removeAttribute('aria-busy'));
      }
    },

    async sync() {
      if (this.busy) return;
      const box = this.box();
      if (!box) return;
      const keys = this.keys(box);
      const extra = box.dataset.qualified === 'true' ? keys.slice(1) : keys;
      if (!extra.length) return;
      this.busy = true;
      try {
        for (const key of extra) await cart.change(key, 0);
      } catch (error) {
        /* the next cart change tries again */
      } finally {
        this.busy = false;
      }
    },

    openDialogOnce() {
      const dialog = document.getElementById('FreeGiftDialog');
      if (!dialog || dialog.dataset.auto !== 'true' || typeof dialog.showModal !== 'function') return;
      const storageKey = 'erstwhile:free-gift-seen';
      try {
        if (localStorage.getItem(storageKey)) return;
      } catch (error) {
        return;
      }
      setTimeout(() => {
        /* not on top of an open menu, cart or other popup */
        if (dialog.open || $('dialog[open]') || $('drawer-panel.is-open')) return;
        dialog.showModal();
        try {
          localStorage.setItem(storageKey, String(Date.now()));
        } catch (error) {
          /* private mode: it may show again next visit */
        }
      }, Number(dialog.dataset.delay) || 4000);
    },
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-free-gift-choose]');
    if (!option) return;
    event.preventDefault();
    if (option.disabled || option.getAttribute('aria-pressed') === 'true') return;
    freeGift.choose(option);
  });
  document.addEventListener('cart:updated', () => freeGift.sync());
  /* opening the popup from the banner counts as seen */
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-dialog-open="FreeGiftDialog"]')) return;
    try {
      localStorage.setItem('erstwhile:free-gift-seen', String(Date.now()));
    } catch (error) {
      /* ignore */
    }
  });

  theme.freeGift = freeGift;

  const initFreeGift = () => {
    freeGift.sync();
    freeGift.openDialogOnce();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFreeGift);
  else initFreeGift();

})();
